import { EventType } from './event-type.interface';

export const WATER: EventType = {
  name: 'Water',
  description: 'When a water sensor indicates the presence of water',
  route: 'water',
  category: 'Sensors',
  icon: 'water',
  whitelist: [
    {
      proxy: 'contactsingle_watersensor_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/water.type.ts